var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex w-100 gap-20" }, [
    _vm.response.method === "Structural Similarity Index Measure"
      ? _c(
          "div",
          {
            staticClass: "box",
            class: _vm.renderSimilarityClass(_vm.similarity),
          },
          [
            _c("strong", [_vm._v(_vm._s(_vm.translate("Similarity")))]),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.similarity) + "%")]),
          ]
        )
      : _c(
          "div",
          {
            staticClass: "box",
            class: _vm.renderDifferenceClass(_vm.percentDiff),
          },
          [
            _c("strong", [_vm._v(_vm._s(_vm.translate("Difference")))]),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.percentDiff) + "%")]),
          ]
        ),
    _vm._v(" "),
    _c("table", { staticClass: "table bg-white table-bordered m-0" }, [
      _c("thead", { staticClass: "thead-light" }, [
        _c("tr", [_c("th", [_vm._v(_vm._s(_vm.translate("Method")))])]),
      ]),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [_c("td", [_vm._v(_vm._s(_vm.response.method))])]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }